export default "__VITE_PUBLIC_ASSET__1c11fb62__"